/**
 * Theme configuration for Ink UI components
 */

export const theme = {
    colors: {
        primary: '#6366f1',      // Indigo
        success: '#22c55e',      // Green
        warning: '#eab308',      // Yellow
        error: '#ef4444',        // Red
        muted: '#6b7280',        // Gray
        border: '#374151',       // Dark gray
        text: '#f3f4f6',         // Light gray
        background: '#1a1a2e',   // Dark background
    },

    icons: {
        success: '✅',
        error: '❌',
        pending: '○',
        loading: '⏳',
        package: '📦',
        folder: '📁',
        file: '📄',
        tip: '💡',
        warning: '⚠️',
        checkmark: '✓',
        arrow: '→',
        bullet: '•',
    },

    borders: {
        single: {
            topLeft: '┌',
            topRight: '┐',
            bottomLeft: '└',
            bottomRight: '┘',
            horizontal: '─',
            vertical: '│',
        },
        double: {
            topLeft: '╔',
            topRight: '╗',
            bottomLeft: '╚',
            bottomRight: '╝',
            horizontal: '═',
            vertical: '║',
        },
    },
} as const;

export type Theme = typeof theme;
